module.exports = __webpack_public_path__ + "static/media/V2_14.514225ce.png";